/**
 * Сравнение строк при поиске по порталу (FR-ADM-038).
 *
 * «ё» в русском письме необязательна: одну и ту же вещь называют «счёт» и
 * «счет», и какую из букв набрал человек — дело случая, а не смысла. Поиск,
 * который их различает, отвечает «ничего не нашлось» на запрос «сче» и
 * находит по нему же «в счетах»: с точки зрения того, кто ищет, портал
 * просто сломан.
 *
 * Одно место на все поиски портала — палитру команд и палитру нод: правило
 * из двух строк, заведённое дважды, через месяц действует в одном из них.
 *
 * Регистр приводится с указанием языка: `toLowerCase()` без него для
 * турецкой локали превращает «I» не в ту букву, а список локалей в портале
 * не наш выбор — он приходит из настроек браузера.
 */
export function дляСравнения(текст: string): string {
  return текст.toLocaleLowerCase('ru').replace(/ё/gu, 'е')
}

/** Содержит ли название то, что набрали. Пустой запрос подходит всему. */
export function подходитЗапросу(текст: string, запрос: string): boolean {
  const набрано = дляСравнения(запрос.trim())
  if (набрано === '') return true
  return дляСравнения(текст).includes(набрано)
}
